module.exports = __webpack_public_path__ + "static/6gde-d08eaa58e93b2e39571285c790ff5b0b.gif";